import React, { useState, useContext } from "react";

import Select from "../Select/Select";
import countries from "../countries";
import "./Formdate.css"
import days from "./day"
import months from "./month"
import { SquareContext } from "../../SquareContext";

export default function Fromdate(props) {


  const {day, setDay, month, setMonth, year, setYear  } = useContext(SquareContext);



  const today = new Date();


  return (
    <>
      <form className="form-style form-flex">
        <ul>
          <li>
            <select
             value={day}
              name="country"
              // value={country}
              className="field-style field-date align-left field-select"
              placeholder="Country"
              onChange={(e) => setDay(e.target.value)}
              required
            >
              <option value="" disabled >
                day
              </option>
              {days.map((el) => (
                <option key={el}>{el}</option>
              ))}
            </select>
            <select
            value={month}
              name="country"
              // value={country}
              className="field-style field-date align-right field-select"
              placeholder="Country"
              onChange={(e) => setMonth(e.target.value)}
              required
            >
              <option value="" disabled >
                month
              </option>
              {months.map((el) => (
                <option key={el}>{el}</option>
              ))}
            </select>
            <select
             value={year}
              name="country"
              // value={country}
              className="field-style field-date align-right field-select"
              placeholder="Country"
              onChange={(e) => setYear(e.target.value)}
              required
            >
              <option value="" disabled >
                year
              </option>
              
                <option key="1y">{today.getFullYear()}</option>
                <option key="2y">{today.getFullYear() + 1}</option>
                <option key="3y">{today.getFullYear() + 2}</option>
            </select>
          </li>
          
       
         
         
        
        </ul>
      </form>
    </>
  );
}
